<style>
/* .box {
  padding-top: 50px;
  display: inline-block;
  width: 260px;
} */
.btn-opcion {
  width: 270px;
  margin: 20px;
  display: block;
}
button {
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Seac Pagos</b-card-header>
      <b-card-body>
        <div class="col-12 text-center">
          Servicio de cobro con tarjetas de crédito y débito
          <!-- <a
            @click="verInformacionComisiones()"
            style="padding: 2px; cursor: pointer;"
          >
            <img src="/img/Informacion.8f90e30c.png" style="width: 20px;height:20px" />
          </a> -->
        </div>
        <div class="col-12 text-center" style="margin-top:10px">
          <div>
            <img src="@/assets/smartpost-gray.png" style="width: 200px;" />
          </div>

          <div
            style="display: flex; flex-direction: column; align-items: center; margin-top: 10px;"
          >
            <button
              class="btn btn-danger btn-opcion"
              type="button"
              @click="verListadoOperaciones()"
              style="margin: 10px; padding: 10px 20px; line-height: 1.2;"
            >Listado de Operaciones</button>
            <button
              v-if="!isCashierOrSupervisor"
              class="btn btn-danger btn-opcion"
              type="button"
              @click="verListadoAcreditacones()"
              style="margin: 10px; padding: 10px 20px; line-height: 1.2;"
            >Listado de Acreditaciones</button>
            <button
              v-if="!isCashierOrSupervisor"
              class="btn btn-danger btn-opcion"
              type="button"
              @click="verCalendarioAcreditacones()"
              style="margin: 10px; padding: 10px 20px; line-height: 1.2;"
            >Calendario de Acreditaciones</button>
            <!-- <button
              class="btn btn-danger btn-opcion"
              type="button"
              @click="verAcreditacionesPendientes()"
              style="margin: 10px; padding: 10px 20px; line-height: 1.2;"
            >Adelantos de Cobros</button>
            <button
              class="btn btn-danger btn-opcion"
              type="button"
              @click="verMisDispositivos()"
              style="margin: 10px; padding: 10px 20px; line-height: 1.2;"
            >Mis Dispositivos</button> -->
            <button
              v-if="!isCashierOrSupervisor"
              class="btn btn-danger btn-opcion"
              type="button"
              @click="verConfiguracionCostos()"
              style="margin: 10px; padding: 10px 20px; line-height: 1.2;"
            >Configuración de Costos</button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import store from "@/store";

export default {
  name: "SmartPost",
  data() {
    return {};
  },
  computed: {
    isCashierOrSupervisor() {
      return store.getters.isCashier || store.getters.isAccountTypeSupervisor;
    }
  },
  methods: {
    verInformacionComisiones() {
      let context = this;
      context.$router.push({ name: "InformacionComisionesFintouch" });
    },
    verMisDispositivos() {
      let context = this;
      context.$router.push({ name: "MisDispositivos" });
    },
    verAcreditacionesPendientes() {
      let context = this;
      context.$router.push({ name: "AcreditacionesPendientes" });
    },
    verListadoOperaciones() {
      let context = this;
      context.$router.push({ name: "ListadoOperaciones" });
    },
    verListadoAcreditacones() {
      let context = this;
      context.$router.push({ name: "ListadoAcreditaciones" });
    },
    verCalendarioAcreditacones() {
      let context = this;
      context.$router.push({ name: "CalendarioAcreditaciones" });
    },
    verConfiguracionCostos() {
      let context = this;
      context.$router.push({ name: "ConfiguracionCostos" });
    }
  }
};
</script>